module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/step-4-buyback_1212bce7e85c53dc21e15e0b4304ffae.png";